import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { RoleDetail } from '../models/role.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

export interface RoleDrawerOptions {
  /** Definido → modo edición / lectura sobre un rol existente. */
  roleId?: number;
  /** true → solo lectura (roles de sistema). */
  readOnly?: boolean;
}

@Injectable({ providedIn: 'root' })
export class RoleDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: RoleDrawerOptions }>({
    isOpen: false,
    options: {},
  });

  private readonly saved$$ = new Subject<RoleDetail>();

  readonly state = this.state$.asObservable();
  readonly saved$ = this.saved$$.asObservable();

  open(options: RoleDrawerOptions = {}): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false, options: {} });
  }

  notifySaved(role: RoleDetail): void {
    this.saved$$.next(role);
  }
}
